import React from 'react';


const ChemDraw = () => {
  return (
    <iframe id="ifKetcher" src={`${window.location.origin}/app/ketcher/`} width="800" height="600"></iframe>
  );
};

export default ChemDraw;
